<template>
    <div class="card profile-card">
      <online :last_activity="user.profile.last_activity" />
      <div class="profile-more" v-if="!itsYou && !user.profile.deleted" @click="$emit('setChoise')">
          <img src="@/assets/images/icons/more-c.svg">
      </div>
      <div
        class="card__avatar"
        @click="openAvatar(getAvatar)"
        :style="{ backgroundImage: 'url(' + getAvatar + ')' }"
      >
        <!-- <div class="rate" v-if="user.profile.score" @click.stop="$emit('setRate')">
          <div class="rate__emoji">
            <img :src="require(`@/assets/images/emoji/${user.profile.score.level.icon}.svg`)" width="20" />
          </div>
          <p>{{user.profile.score.level.name}}</p>
        </div> -->
        <div v-if="loading_avatar" class="card__avatar_loader">
          <Loader :color="'black'" />
        </div>
        <div class="card-panel" v-if="itsYou">
          <div class="card-panel__item" @click.stop>
            <font-awesome-icon icon="pencil-alt" />
            <input
              class="card-panel__input"
              type="file"
              @change="loadPhoto($event, 'avatars')"
              name="avatar"
              max-size="10000"
              accept="image/*"
              title="Изменить аватарку"
            />
          </div>
        </div>
      </div>
      <div class="card-wrap">
        <!-- Имя Фамилия -->
        <h1 class="card__name" v-if="!itsYou">{{ user.profile.firstname + ' ' + user.profile.lastname }}</h1>
        <div class="card-string" v-else>
          <input class="card__input" type="text" :value="user.profile.firstname" @change="changeName('firstname', $event)" />
          <input class="card__input" type="text" :value="user.profile.lastname" @change="changeName('lastname', $event)" />
        </div>
        <!-- Nickname -->
        <p class="card__status" v-if="!itsYou">@{{ user.profile.nickname }}</p>
        <input class="card__status_input" type="text" v-else :value="'@' + user.profile.nickname" @change="changeName('nickname', $event)" />
        
        <!-- Sports -->
        <div class="button card-add-sports" @click="$emit('setSports')" v-if="(!user.profile.sports || user.profile.sports.length == 0) && itsYou">Добавить интересы</div>
        <div class="people-category">
          <div
            class="sport"
            v-for="cat in shortSports"
            :key="cat.id"
            :class="cat.color"
            @click="$emit('setSports')"
          >
            {{ cat.ru }}
          </div>
          <div class="people-category__item dark" v-if="user.profile.sports.length > 5">и еще {{user.profile.sports.length - 5}}</div>
        </div>

        <!-- Инфо текст -->
        <p v-if="user.profile.country && user.profile.state" class="card__text">{{ user.profile.country + ', '+ user.profile.state }}</p>
        <p class="card__text" v-if="!user.profile.deleted">{{ user.profile.sex }}{{ getYears }}</p>
        <p class="card__text" v-else >Пользователь удален</p>
        <!-- Buttons -->
        <div class="card-buttons" v-if="!user.profile.deleted">
          <div class="map-button map-button_main" v-if="itsYou" @click="$emit('setEditor')">
            <p>Редактировать</p>
          </div>
          <div class="map-button map-button_green" v-if="!itsYou && !friendship && !youInviteHim" @click="addFriend()">
            <p>Добавить в друзья</p>
          </div>
          <div class="map-button map-button_green" v-if="!itsYou && friendship" @click="deleteFriend()">
            <p>У вас в друзьях</p>
          </div>
          <div class="map-button map-button_green" v-if="!itsYou && youInviteHim" @click="cancelInvite()">
            <p>Заявка отправлена</p>
          </div>
          <div class="button-icon blue" v-if="!itsYou" @click="sendMessage">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.903 8.851l-4.444 3.613c-.84.666-2.02.666-2.86 0L6.12 8.851"/>
              <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.909 21C19.95 21.008 22 18.51 22 15.438V8.57C22 5.499 19.95 3 16.909 3H7.09C4.05 3 2 5.499 2 8.57v6.868C2 18.51 4.05 21.008 7.091 21h9.818z" clip-rule="evenodd"/>
            </svg>
          </div>
        </div>
    </div>
    </div>
</template>
<script>
export default {
    name: 'ProfileCard',
    data: () => {
      return {
        loading_avatar: false,
        sports: false,
        choise: null
      }
    },
    props: {
        user: {
            type: Object,
            require: true
        },
        itsYou: {
            type: Boolean,
            require: true
        }
    },
    components: {
        Online: () => import('@/components/Users/Online'),
        Loader: () => import('@/components/UI/Loader.vue')
    },
    computed: {
      getUser () {
        return this.$store.getters.getAuthUser
      },
      getAvatar() {
        return this.user.profile.deleted ? require('@/assets/images/defaults/dead.svg') : this.user.profile.avatar
      },
      friendship() {
        return this.getUser && this.user.profile.friends.find(friend => friend.id === this.getUser.id) 
      },
      youInviteHim() {
        return this.getUser && this.user.offers.invites.find(invite => invite.id_from === this.getUser.id) 
      },
      shortSports() {
        return this.user.profile.deleted ? [] : this.user.profile.sports.slice(0, 5)
      },
      getYears() {
        let bithday = this.user.profile.birthday;
        let result = null;
        if (bithday) {
          let bDate = this.$moment(this.user.profile.birthday);
          let today = this.$moment();
          let duration = this.$moment.duration(today.diff(bDate));
          result = ', ' + Math.round(duration.asYears()) + ' лет';
        }
        return result
      },
    },
    methods: {
      async cancelInvite() {
        let result = await this.$store.dispatch('cancelOffer', {from: this.getUser.id, to: this.user.profile.id})
        if (result) {
          let finded = this.user.offers.invites.find(user => user.id_from === this.getUser.id);
          this.user.offers.invites.splice(this.user.offers.invites.indexOf(finded), 1)
        } else {
          this.$store.dispatch('addError', 'Что-то пошло не так')
        }
      },
      async addFriend() {
        let result = await this.$store.dispatch('sendOffer', {from: this.getUser.id, to: this.user.profile.id});
        this.$store.dispatch('createNotification', {from_id: this.getUser.id, user: this.user.profile.id, type: 'new_friendship'} )
        if (result) {
            this.$store.dispatch('addNotification', {message: "Ваша заявка отправлена!"});
            this.user.offers.invites.push({id_from: this.getUser.id, id_to: this.user.profile.id})
          } else {
            this.$store.dispatch('addError', 'Что-то пошло не так')
          } 
        // result ? this.user.profile.friends.push(this.getUser) : this.$store.dispatch('addError', 'Что-то пошло не так') для офферсов
      },
      async deleteFriend() {
        let result = await this.$store.dispatch('deleteFriend', {user: this.getUser.id, friend: this.user.profile.id});
        if (result) {
          let finded = this.user.profile.friends.find(user => user.id === this.getUser.id);
          this.user.profile.friends.splice(this.user.profile.friends.indexOf(finded), 1)
        } else {
          this.$store.dispatch('addError', 'Что-то пошло не так')
        }
      },
      openAvatar(photo) {
        this.$store.dispatch('setPhotos', {photos: [photo], active: 0})
        this.$store.dispatch('setPhotosState', true)
      },
      loadPhoto(input, path) {
        let element = input.target.files[0];

        if (element.size / 1024 > 10000) {
          this.$store.dispatch('addError', {message: 'Размер фотографии превышает 10MB'});
        } else {
          var reader = new FileReader();
          reader.readAsDataURL(element)
          reader.onload = async () => {
            let url = reader.result;
            let type = element.type.split('/')[1];
            let size = element.size / 1024;
            let name = this.getUser.nickname.split('@')[0] + '-' + this.$moment().format('ss-mm-HH_DD-MM-YYYY') + '_';
            this.loading_avatar = true;
            await this.$store.dispatch('uploadImage', {url, type: type || 'jpeg', name, size, path})
              .then(response => {
                response.Location ? this.addAvatar(response.Location) : (this.loading_avatar = false, this.$store.dispatch('addError', {message: 'Не удалось загрузить изображение'}));
              }).catch(e => {e
                this.loading_avatar = false;
                this.$store.dispatch('addError', {message: 'Не удалось загрузить изображение'})
              });
          };

          reader.onerror = function() {
            this.$store.dispatch('addError', {message: 'Что-то пошло не так...'})
          };
          
          
        }
      },
      async addAvatar(url) {
        await this.$store.dispatch('editUser', {options: {type: 'avatar', value: url}, user: this.getUser.id});
        await this.$store.dispatch('editProfile', {key: 'avatar', val: url});
        this.loading_avatar = false
      },
      async changeName(type, val) {
        let value = val.target.value;
        value = type === 'nickname' ? value.split('@').join('') : value;
        let messages = {
          lastname: 'Ваша фамилия обновлена',
          firstname: 'Ваше имя обновлено',
          about: 'Информация о вас была обновлена',
          nickname: 'Ваш никнэйм был обновлён'
        };
        await this.$store.dispatch('editUser', {options: {type: type, value }, user: this.getUser.id})
          .then(() => {
            messages[type] ? this.$store.dispatch('addNotification', {message: messages[type]}) : '';
          })
          .catch(() =>{
            this.$store.dispatch('addError', {message: 'Что-то пошло не так'})
          });
      },
      async sendMessage () {
        let you = this.getUser;
        let user = this.user.profile;
        let data = {
          users: [you.id, user.id],
          locked: true,
          title: 'dialog-'+ you.id + '-' + user.id,
          can_add: false,
          author: {id: you.id},
          to: {id: user.id},
          type: 'dialog'
        };
        let chat = await this.$store.dispatch('createChat', data);
        this.$router.push({name: 'chat', params: {hash: chat.id + '&' + 'dialog-' + you.id + '-' + user.id}})
      },
    }
}
</script>